import PropTypes from "prop-types";
import React, { useEffect, useRef, useCallback } from "react";

//Import Icons
import Icon from "@ailibs/feather-react-ts";
import SimpleBar from "simplebar-react";

//i18n
import { withTranslation } from "react-i18next";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

const SidebarContent = (props: any) => {
  const ref = useRef<any>();

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul: any = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
    document.body.classList.remove("sidebar-enable");
  }, [props.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item: any) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Propiedades")} </li>
            <li>
              <a href={`${process.env.PUBLIC_URL}/properties/0`} className="">
                <Icon name="plus-square" />
                <span>{props.t("Crear propiedad")}</span>
              </a>
            </li>
            <li>
              <Link to="/properties" className="">
                <Icon name="list" />
                <span>{props.t("Listado")}</span>
              </Link>
            </li>

            {/*
              <li className="menu-title">{props.t("Novedades")} </li>
              <li>
                <a href={`${process.env.PUBLIC_URL}/news/0`} className="">
                  <Icon name="plus-square" />
                  <span>{props.t("Crear novedad")}</span>
                </a>
              </li>
              <li>
                <Link to="/news" className="">
                  <Icon name="list" />
                  <span>{props.t("Listado")}</span>
                </Link>
              </li>
              */}

            <li className="menu-title">{props.t("Páginas dinámicas")} </li>
            <li>
              <Link to="/home" className="">
                <Icon name="home" />
                <span>{props.t("Home")}</span>
              </Link>
            </li>
            <li>
              <Link to="/banners" className="">
                <Icon name="image" />
                <span>{props.t("Banners")}</span>
              </Link>
            </li>
            <li>
              <Link to="/agent" className="">
                <Icon name="calendar" />
                <span>{props.t("Agente")}</span>
              </Link>
            </li>
            {/*<li>
              <Link to="/aboutUs" className="">
                <Icon name="plus-square" />
                <span>{props.t("Sobre Nosotros")}</span>
              </Link>
            </li>*/}
            <li>
              <a href={`${process.env.PUBLIC_URL}/propuesta`} className="">
                <Icon name="edit" />
                <span>{props.t("Propuesta comercial")}</span>
              </a>
            </li>
            <li>
              <a href={`${process.env.PUBLIC_URL}/empresa`} className="">
                <Icon name="edit" />
                <span>{props.t("Empresa")}</span>
              </a>
            </li>
            <li>
              <a
                href={`${process.env.PUBLIC_URL}/properties-config`}
                className=""
              >
                <Icon name="edit" />
                <span>{props.t("Propiedades")}</span>
              </a>
            </li>
            <li>
              <a href={`${process.env.PUBLIC_URL}/growth-config`} className="">
                <Icon name="edit" />
                <span>{props.t("Desarrollo")}</span>
              </a>
            </li>
            <li>
              <a href={`${process.env.PUBLIC_URL}/contact`} className="">
                <Icon name="edit" />
                <span>{props.t("Contacto")}</span>
              </a>
            </li>

            <li className="menu-title">{props.t("Layout")} </li>
            <li>
              <Link to="/navbar" className="">
                <Icon name="layout" />
                <span>{props.t("Navbar")}</span>
              </Link>
            </li>
            <li>
              <Link to="/footer" className="">
                <Icon name="layout" />
                <span>{props.t("Footer")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Reseñas")} </li>
            <li>
              <Link to="/ratings" className="">
                <Icon name="message-square" />
                <span>{props.t("Reseñas")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Cuenta")} </li>
            <li>
              <Link to="/config" className="">
                <Icon name="settings" />
                <span>{props.t("Configuración")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Suscriptores")} </li>
            <li>
              <Link to="/subscriptors" className="">
                <Icon name="users" />
                <span>{props.t("Listado")}</span>
              </Link>
            </li>
            <li className="menu-title">{props.t("Contactos")} </li>
            <li>
              <Link to="/contacts" className="">
                <Icon name="mail" />
                <span>{props.t("Listado")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Visitas")} </li>
            <li>
              <Link to="/bookings-list" className="">
                <Icon name="book" />
                <span>{props.t("Listado")}</span>
              </Link>
            </li>
            <li>
              <Link to="/bookings" className="">
                <Icon name="calendar" />
                <span>{props.t("Calendario")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withTranslation()(withRouter(SidebarContent));
